<template>
    <div>
        <div class="g-popup preview" v-show="showqqVerify">
            <!-- 未实名认证弹窗 [[ -->
            <div class="popup-con accept-popup js-popup-accept">
                <div class="popup-close js-close-view" @click="showqqVerify = false"><i class="ico ico-close"></i></div>
                <h5 class="popup-title">QQ钱包未实名验证，请绑定与TGL一致的信息</h5>
                <div class="confirm-content">
                    <div class="pop-title">QQ钱包实名注册：
                        <span class="font-bold">QQ钱包</span>
                        -
                        <span class="font-bold">设置</span>
                        -
                        <span class="font-bold">实名认证</span>
                        -
                        <span class="font-bold">绑定银行卡</span>
                        -
                        <span class="font-bold">上传身份证照片验证</span><br />QQ钱包验证后，请重新登录TGL账号。
                    </div>
                    <img class="bind-img" src="~Assets/img/pages/v4/bind1.png"/>
                </div>
            </div>
            <!-- 未实名认证弹窗 ]] -->
        </div>

        <div class="g-popup preview" v-show="showTglAndQqVerify">
            <!-- 已实名，但与TGL不一致 [[ -->
            <div class="popup-con accept-popup js-popup-atypism">
                <div class="popup-close js-close-view" @click="showTglAndQqVerify = false"><i class="ico ico-close"></i></div>
                <h5 class="popup-title">QQ钱包验证，请绑定与TGL一致的信息</h5>
                <div class="confirm-content">
                    <div class="pop-title">QQ钱包实名注册：
                        <span class="font-bold">QQ钱包</span> - <span class="font-bold">设置</span> - <span class="font-bold">实名认证</span> - <span class="font-bold">注销账号</span> - <span class="font-bold">重新实名</span>
                        <br />QQ钱包验证后，请重新登录TGL账号。
                    </div>
                    <img class="bind-img" src="~Assets/img/pages/v4/bind2.png"/>
                </div>
            </div>
            <!-- 已实名，但与TGL不一致 ]] -->
        </div>
    </div>
</template>
<style lang="scss" scoped>
    @import '~Assets/sass/pages/v4/common/_config_theme.scss';
    // 图片弹窗内容
    .accept-popup{
        padding-top: 30px;
        width: 682px;
        .confirm-content {
            padding-top: 30px;
        }
        .pop-title{
            width: 584px;
            margin: 0 auto;
            padding: 0 0 20px;
            font-size: $middle-font;
            color: $color-warn;
            text-align: center;
            line-height: 20px;
            border-bottom: 1px solid $color-border2;
            .font-bold{
                color: $color-gray;
                font-weight: bold;
            }
        }
        .bind-img{
            display: block;
            margin: 0 auto;
        }
    }
</style>
<script>
export default {
    data(){
        return {
            showqqVerify: false,
            showTglAndQqVerify: false
        }
    }
}
</script>
